module.exports = __webpack_public_path__ + "static/media/deleteDark.cc96a6cc.svg";